import FootballState from "../../../../../sports/football/state/football-state";
import { FragmentSerializer } from "./FragmentSerializer";

export class PuntFragmentSerializer extends FragmentSerializer {
    applicable(fragment) {
        return [FootballState.Punt, FootballState.CflKick].some(
            (state) => fragment.associatedState === state
        );
    }

    getRawFragment(play, serializationContext, punt) {
        let rawPlay = "";

        const filteredFragments = play.getFragmentsBetween(punt, [
            FootballState.CflKick
        ]);

        const puntBlocked = filteredFragments.find(
            ({ associatedState }) =>
                associatedState === FootballState.PuntBlocked
        );

        const formattedFieldPosition = this.resolveFormattedFieldPosition(
            serializationContext,
            punt.getFieldPosition()
        );

        let values = [
            this.resolveUniform(serializationContext, punt.puntedBy),
            formattedFieldPosition
        ];
        if (puntBlocked) {
            const recovery = filteredFragments.find(({ associatedState }) =>
                [
                    FootballState.KickRecovered,
                    FootballState.KickNotRecovered
                ].some((state) => state === associatedState)
            );

            const teamSide = this.resolveTeam(
                serializationContext,
                recovery.recoveredBy
            );

            const at = this.resolveFormattedFieldPosition(
                serializationContext,
                recovery.getFieldPosition()
            );

            values = [
                ...values,
                "B",
                teamSide,
                at,
                this.resolveUniform(
                    serializationContext,
                    recovery.getPlayers()[0]
                )
            ];
        }

        rawPlay = `PUNT:${values.join()}`;

        return rawPlay;
    }
}
